// StoreSignUp.js
import React, { useState } from 'react';
import './PublicSignUp.css';

export default function StoreSignUp() {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    storeStatus: 'Pending',
    storeActiveDate: '',
    storeNumber: '',
    storeName: '',
    storeAddress: '',
    storeCity: '',
    storeState: '',
    storeZip: '',
    storePhoneNumber: '',
    storeMainEmail: '',
    storePrimaryContact: '',
    storePrimaryPhoneNumber: '',
    storePrimaryEmail: '',
    storeSecondaryContact: '',
    storeSecondaryPhoneNumber: '',
    storeSecondaryEmail: '',
    openpathOrgID: '',
    cloverMID: '',
    Clover_ID_3mo: '',
    Clover_ID_6mo: '',
    Clover_ID_1yr: '',
    honeypot: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.honeypot) {
      alert("Bot detected.");
      return;
    }

    setIsSubmitting(true);

    try {
      const res = await fetch('https://rgs-a.azurewebsites.net/api/Master_Function', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          target: 'New_Store_Setup',
          payload: {
            ...formData
          }
        })
      });

      if (!res.ok) throw new Error('Submission failed');
      alert("✅ Store submitted successfully!");
    } catch (err) {
      console.error(err);
      alert("❌ Submission failed.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <form className="container" onSubmit={handleSubmit}>
      <h1 className="header">New Store Setup</h1>

      <div className="cardSection">
        <div className="card">
          <select className="select" name="storeStatus" value={formData.storeStatus} onChange={handleChange} required>
            <option value="Pending">Pending</option>
            <option value="Active">Active</option>
            <option value="Suspended">Suspended</option>
            <option value="Closed">Closed</option>
          </select>

          <input className="input" type="date" name="storeActiveDate" value={formData.storeActiveDate} onChange={handleChange} required />
          <input className="input" name="storeNumber" placeholder="Store Number" value={formData.storeNumber} onChange={handleChange} required />
          <input className="input" name="storeName" placeholder="Store Name" value={formData.storeName} onChange={handleChange} required />
          <input className="input" name="storeAddress" placeholder="Store Address" value={formData.storeAddress} onChange={handleChange} required />
          <input className="input" name="storeCity" placeholder="City" value={formData.storeCity} onChange={handleChange} required />
          <input className="input" name="storeState" placeholder="State" value={formData.storeState} onChange={handleChange} required />
          <input className="input" name="storeZip" placeholder="Zip" value={formData.storeZip} onChange={handleChange} required />
          <input className="input" name="storePhoneNumber" placeholder="Store Phone Number" value={formData.storePhoneNumber} onChange={handleChange} required />
          <input className="input" name="storeMainEmail" placeholder="Main Email" value={formData.storeMainEmail} onChange={handleChange} required />

          <h3 className="addonTitle">Primary Contact</h3>
          <input className="input" name="storePrimaryContact" placeholder="Name" value={formData.storePrimaryContact} onChange={handleChange} required />
          <input className="input" name="storePrimaryPhoneNumber" placeholder="Phone Number" value={formData.storePrimaryPhoneNumber} onChange={handleChange} required />
          <input className="input" name="storePrimaryEmail" placeholder="Email" value={formData.storePrimaryEmail} onChange={handleChange} required />

          <h3 className="addonTitle">Secondary Contact (Optional)</h3>
          <input className="input" name="storeSecondaryContact" placeholder="Name" value={formData.storeSecondaryContact} onChange={handleChange} />
          <input className="input" name="storeSecondaryPhoneNumber" placeholder="Phone Number" value={formData.storeSecondaryPhoneNumber} onChange={handleChange} />
          <input className="input" name="storeSecondaryEmail" placeholder="Email" value={formData.storeSecondaryEmail} onChange={handleChange} />

          <h3 className="addonTitle">System Integration</h3>
          <input className="input" name="openpathOrgID" placeholder="Openpath Org ID" value={formData.openpathOrgID} onChange={handleChange} required />
          <input className="input" name="cloverMID" placeholder="Clover MID" value={formData.cloverMID} onChange={handleChange} required />
          <input className="input" name="Clover_ID_3mo" placeholder="Clover ID (3mo)" value={formData.Clover_ID_3mo} onChange={handleChange} required />
          <input className="input" name="Clover_ID_6mo" placeholder="Clover ID (6mo)" value={formData.Clover_ID_6mo} onChange={handleChange} required />
          <input className="input" name="Clover_ID_1yr" placeholder="Clover ID (1yr)" value={formData.Clover_ID_1yr} onChange={handleChange} required />

          <input className="honeypot" name="honeypot" value={formData.honeypot} onChange={handleChange} autoComplete="off" tabIndex="-1" />
        </div>
      </div>

      {isSubmitting ? (
        <div className="spinner"></div>
      ) : (
        <button className="submitButton" type="submit">Submit</button>
      )}
    </form>
  );
}
